import script from "./RcHeading.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcHeading.vue?vue&type=script&setup=true&lang=ts"

import "./RcHeading.vue?vue&type=style&index=0&id=4e4f53cc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4f53cc"]])

export default __exports__